export default __webpack_public_path__ + "static/media/product_placeholder.507c56a0.png";